import React, { useEffect, useState } from "react";
import "./agent.scss";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Card, Col, Container, Form, Input, Label, Row } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import Dropzone from "react-dropzone";
import { Link, useHistory } from "react-router-dom";
import { imageUpload } from "../../services/BannersServices";
import { Constants } from "../../Constants";
import { EditorState } from "draft-js";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import { fetchAgent, putAgent } from "../../services/SharedServices";
import { stateFromHTML } from "draft-js-import-html";
import { stateToHTML } from "draft-js-export-html";
import ViewInWeb from "../../components/Common/ViewInWeb";

function Agent() {
  const [image, setImage] = useState("");
  const [icon1, setIcon1] = useState("");
  const [link1, setLink1] = useState("");
  const [title1, setTitle1] = useState("");
  const [icon2, setIcon2] = useState("");
  const [link2, setLink2] = useState("");
  const [title2, setTitle2] = useState("");
  const [icon3, setIcon3] = useState("");
  const [link3, setLink3] = useState("");
  const [title3, setTitle3] = useState("");
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState(EditorState.createEmpty());
  const history = useHistory();

  useEffect(() => {
    fetch();
  }, []);

  const uploadCallback = async (file: any) => {
    const result = {
      data: {
        link: "",
      },
    };
    try {
      var form = new FormData();
      form.append("file", file);
      let response = await imageUpload({
        form,
        token: "",
        type: "textEdition",
      });
      result.data.link = `${Constants.BASE_URL}${response.data.data.image}`;
    } catch (error: any) {
      console.log(error.response);
    }
    return result;
  };

  const handleAcceptedFiles = async (files: any, key: string) => {
    for (let file of files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "agent",
        });
        if (key === "image") {
          setImage(response.data.data.image);
        }
        if (key === "icon1") {
          setIcon1(response.data.data.image);
        }
        if (key === "icon2") {
          setIcon2(response.data.data.image);
        }
        if (key === "icon3") {
          setIcon3(response.data.data.image);
        }
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };

  const fetch = async () => {
    try {
      setLoading(true);
      let response = await fetchAgent({
        token: "",
      });
      let {
        description,
        image,
        icon1,
        enlace1,
        title1,
        icon2,
        enlace2,
        title2,
        icon3,
        enlace3,
        title3,
      } = response.data.data.config;
      setLoading(false);
      setDescription(EditorState.createWithContent(stateFromHTML(description)));
      setImage(image);
      setIcon1(icon1);
      setIcon2(icon2);
      setIcon3(icon3);
      setLink1(enlace1);
      setLink2(enlace2);
      setLink3(enlace3);
      setTitle1(title1);
      setTitle2(title2);
      setTitle3(title3);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const save = async () => {
    setLoading(true);
    try {
      let response = await putAgent({
        token: "",
        description: stateToHTML(description.getCurrentContent()),
        image: image,
        icon1: icon1,
        icon2: icon2,
        icon3: icon3,
        enlace1: link1,
        enlace2: link2,
        enlace3: link3,
        title1: title1,
        title2: title2,
        title3: title3,
      });
      setLoading(false);
      toast(`Seccíon guardada con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {loading && <Loading />}
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Agente" breadcrumbItem="Agente" />
          <Row>
            <Col>
              <Label>Descripción</Label>
              <Editor
                toolbarClassName="toolbarClassName"
                wrapperClassName="wrapperClassName"
                editorClassName="editorClassName"
                toolbar={{
                  options: ["inline", "blockType", "link", "emoji", "image"],
                  inline: { inDropdown: true },
                  link: { inDropdown: true },
                  image: { uploadCallback },
                }}
                editorState={description}
                onEditorStateChange={(d: any) => setDescription(d)}
              />
              <h5 className="mt-4">Imagen</h5>
              <div className="row">
                <div className="col-12">
                  <Dropzone
                    onDrop={(acceptedFiles) => {
                      handleAcceptedFiles(acceptedFiles, "image");
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="dropzone">
                        <div
                          className="dz-message needsclick mt-2"
                          {...getRootProps()}
                        >
                          <input {...getInputProps()} />
                          <div className="mb-3">
                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                          </div>
                          <h4>Drop files here or click to upload.</h4>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                  <div className="dropzone-previews mt-3" id="file-previews">
                    {image && (
                      <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                        <div className="p-2">
                          <Row className="align-items-center">
                            <Col className="col-auto">
                              <img
                                data-dz-thumbnail=""
                                height="80"
                                className="avatar-sm rounded bg-light"
                                alt=""
                                src={`${Constants.BASE_URL}${image}`}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Card>
                    )}
                  </div>
                </div>
              </div>

              <div className="row" style={{ marginTop: "2rem" }}>
                <IconItem
                  icon={icon1}
                  link={link1}
                  setLink={setLink1}
                  title={title1}
                  setTitle={setTitle1}
                  handleAcceptedFiles={handleAcceptedFiles}
                  iconKey="icon1"
                />
                <IconItem
                  icon={icon2}
                  link={link2}
                  setLink={setLink2}
                  title={title2}
                  setTitle={setTitle2}
                  handleAcceptedFiles={handleAcceptedFiles}
                  iconKey="icon2"
                />
                <IconItem
                  icon={icon3}
                  link={link3}
                  setLink={setLink3}
                  title={title3}
                  setTitle={setTitle3}
                  handleAcceptedFiles={handleAcceptedFiles}
                  iconKey="icon3"
                />
              </div>
              <div className="row" style={{ marginTop: "1rem" }}>
                <div className="col-12 text-right">
                  <ViewInWeb link="https://mariomendez.uy" />
                  <button
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => save()}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export const IconItem = ({
  icon,
  link,
  setLink,
  handleAcceptedFiles,
  iconKey,
  ignoreLink,
  title,
  setTitle,
}: any) => (
  <div className={`${!ignoreLink ? "col-4" : ""}`}>
    <h5>{iconKey}</h5>
    <Dropzone
      onDrop={(acceptedFiles) => {
        handleAcceptedFiles(acceptedFiles, iconKey);
      }}
    >
      {({ getRootProps, getInputProps }) => (
        <div className="dropzone">
          <div className="dz-message needsclick mt-2" {...getRootProps()}>
            <input {...getInputProps()} />
            <div className="mb-3">
              <i className="display-4 text-muted bx bxs-cloud-upload" />
            </div>
            <h4>Drop files here or click to upload.</h4>
          </div>
        </div>
      )}
    </Dropzone>
    <div className="dropzone-previews mt-3" id="file-previews">
      {icon && (
        <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
          <div className="p-2">
            <Row className="align-items-center">
              <Col className="col-auto">
                <img
                  data-dz-thumbnail=""
                  height="80"
                  className="avatar-sm rounded bg-light"
                  alt=""
                  src={`${Constants.BASE_URL}${icon}`}
                />
              </Col>
            </Row>
          </div>
        </Card>
      )}
    </div>
    {!ignoreLink ? (
      <>
        <label style={{ marginTop: "0.5rem" }}>Enlace</label>
        <Input value={link} onChange={(e) => setLink(e.target.value)} />
      </>
    ) : null}
    {setTitle ? (
      <>
        <label style={{ marginTop: "0.5rem" }}>Título</label>
        <Input value={title} onChange={(e) => setTitle(e.target.value)} />
      </>
    ) : null}
  </div>
);

export default Agent;
